import '@/modules/card';
import Swiper from 'swiper';
import SwiperCore, { Navigation } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation]);

export default class ProductIncludedCarousel {
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.arrowNext = sliderElement.closest('.js-product-included-wrap').querySelector('.swiper-button-next');
        this.arrowPrev = sliderElement.closest('.js-product-included-wrap').querySelector('.swiper-button-prev');
        this.init();
    }

    init() {
        const swiper = new Swiper(this.sliderElement, {
            slidesPerView: 1.7,
            spaceBetween: 12,
            threshold: 10,
            speed: 400,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.3
                }
            }
        });

        const updateVisibility = () => {
            const containerRect = this.sliderElement.getBoundingClientRect();
            swiper.slides.forEach(slide => {
                const slideRect = slide.getBoundingClientRect();
                const fullyVisible = slideRect.left >= containerRect.left - 1 && slideRect.right <= containerRect.right + 1;
                slide.classList.toggle('is-partially-visible', !fullyVisible);
            });
        };

        setTimeout(updateVisibility, 0);
        swiper.on('transitionEnd', updateVisibility);
    }
}
